import { render } from "./GameMenu.vue?vue&type=template&id=0864bf8a&scoped=true"
import script from "./GameMenu.vue?vue&type=script&lang=js"
export * from "./GameMenu.vue?vue&type=script&lang=js"

import "./GameMenu.vue?vue&type=style&index=0&id=0864bf8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0864bf8a"]])

export default __exports__